var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FDDE6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.1875C5.58281 15.1875 2.8125 12.4172 2.8125 9C2.8125 5.58281 5.58281 2.8125 9 2.8125C12.4172 2.8125 15.1875 5.58281 15.1875 9C15.1875 12.4172 12.4172 15.1875 9 15.1875ZM9 14.3179C10.4104 14.3179 11.763 13.7576 12.7603 12.7603C13.7576 11.763 14.3179 10.4104 14.3179 9C14.3179 7.58961 13.7576 6.23699 12.7603 5.23969C11.763 4.2424 10.4104 3.68213 9 3.68212C7.58961 3.68213 6.23699 4.2424 5.23969 5.23969C4.2424 6.23699 3.68213 7.58961 3.68212 9C3.68213 10.4104 4.2424 11.763 5.23969 12.7603C6.23699 13.7576 7.58961 14.3179 9 14.3179ZM9.0405 12.6793C7.01719 12.6793 5.38762 11.1324 5.38762 9.02025V9C5.38762 6.93788 6.97669 5.32125 9.1215 5.32125C10.5682 5.32125 11.4992 5.92763 12.1269 6.79669L10.6492 7.93856C10.2442 7.43344 9.77906 7.11 9.10125 7.11C8.10956 7.11 7.4115 7.94869 7.4115 8.97975V9C7.4115 10.0614 8.10956 10.89 9.10125 10.89C9.83981 10.89 10.2752 10.5469 10.6999 10.0311L12.1776 11.0824C11.5093 12.0021 10.6088 12.6793 9.0405 12.6793Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtr);
export default __webpack_public_path__ + "static/media/ctr.84236c9bb610f80b89ba931a7f8e5d4d.svg";
export { ForwardRef as ReactComponent };